<template>
  <div id="issues" :class="cls">
    <h3>{{ this.message(this.$appdata.messages, "issues").label }}</h3>
    <b-row class="justify-content-center">
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="selected"
        :options="options"
        stacked
        class="mb-3 text-left"
        @keyup.native="adv"
      ></b-form-checkbox-group>
    </b-row>
  </div>
</template>
<script>
import { compStyles } from "@/mixins/compStyles";
import { messaging } from "@/mixins/messaging";
import { navigation } from "@/mixins/navigation";
export default {
  props: ["active_key", "active_index", "health_bracket"],
  mixins: [messaging, compStyles, navigation],
  data() {
    return {
      disp_key: 3,
      options: [
        {
          value: "Severe Heart, Pulmonary, Liver, or Kidney Issues",
          text: "Severe Heart, Pulmonary, Liver, or Kidney Issues",
          disabled: false,
          checked: false,
        },
        { value: "Cancer", text: "Cancer", disabled: false },
        {
          value: "Mental Disorders",
          text: "Mental Disorders",
          disabled: false,
        },
        {
          value: "Serious Mobility Issues",
          text: "Serious Mobility Issues",
          disabled: false,
        },
        {
          value: "Other Critical Illness",
          text: "Other Critical Illness",
          disabled: false,
        },
        {
          value: "None of the above",
          text: "None of the above",
          disabled: false,
        },
      ],
      selected: [],
    };
  },

  computed: {
    cls: function () {
      if (this.active_key == this.disp_key) {
        return "component in";
      } else {
        return "component out";
      }
    },
  },
  methods: {
    /**
     * Gets the key of a property element.
     */
    getKey: function (prop, value) {
      var r = null;
      prop.forEach((item, key) => {
        if (item.value == value) {
          r = key;
        }
      });
      return r;
    },
    setProp: function (prop) {
      if (prop.length > 0) {
        this.$emit("setProp", { prop: "nextDisabled", value: false });
      } else {
        this.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
      }
    },
    /**
     * Enables/Disables option checkboxes based on selection.
     */
    enableDisable: function () {
      // Get the index for the "None of the above option"
      var nKey = this.getKey(this.options, "None of the above");
      // If "None of the above" selected,
      // remove other values from the selected property.
      if (this.selected.indexOf(this.options[nKey].value) != -1) {
        this.selected.forEach((item, k) => {
          if (item != this.options[nKey].value) {
            this.selected.splice(k, 1);
          }
        });
        // If "None of the above" selected, disable loop through issues
        // option array and set disabled to true
        this.options.forEach((item, k) => {
          if (item.value != this.options[nKey].value) {
            this.options[k].disabled = true;
          }
        });
      } else {
        // Enable options.
        this.options.forEach((item, k) => {
          if (item.value != this.options[nKey].value) {
            this.options[k].disabled = false;
          }
        });
      }
      // Disable "None of the above" option.
      // If an item is selected and it's not "None of the above" disable none of the above.
      if (
        this.selected.length != 0 &&
        this.selected.indexOf(this.options[nKey].value) == -1
      ) {
        this.options[nKey].disabled = true;
      } else {
        this.options[nKey].disabled = false;
      }
    },
    adv: function (event) {
      if (event.key == "Enter" && this.selected.length > 0) {
        this.incNext();
      }
    },
  },
  watch: {
    active_key: function () {
      if (this.selected.length > 0) {
        this.$emit("setProp", { prop: "nextDisabled", value: false });
      }
    },
    selected: function (n) {
      this.enableDisable();
      this.setProp(n);
      this.$emit("setProp", { prop: "issues", value: this.selected });
    },
  },
  created: function () {
    this.$emit("setProp", { prop: "nextDisabled", value: false });
  },
};
</script>
